module.exports = __webpack_public_path__ + "static/img/plan2.acde836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/pengu/training-plan/plan2.png
// module id = q6fr
// module chunks = 35